var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgTrafficLight = function SvgTrafficLight(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.125 9c-1.087 0-1.969-.895-1.969-2 0-1.11.886-2 1.969-2 1.093 0 1.969.89 1.969 2 0 1.105-.882 2-1.969 2m0 5c-1.087 0-1.969-.895-1.969-2 0-1.11.886-2 1.969-2 1.093 0 1.969.89 1.969 2 0 1.105-.882 2-1.969 2m0 5c-1.087 0-1.969-.895-1.969-2 0-1.11.886-2 1.969-2 1.093 0 1.969.89 1.969 2 0 1.105-.882 2-1.969 2M20 10h-2.953V8.86C18.74 8.41 20 6.86 20 5h-2.953V4c0-.552-.44-1-.985-1H8.188a.99.99 0 0 0-.984 1v1H4.25c0 1.86 1.26 3.41 2.953 3.86V10H4.25c0 1.86 1.26 3.41 2.953 3.86V15H4.25c0 1.86 1.26 3.41 2.953 3.86V20c0 .552.44 1 .984 1h7.876a.99.99 0 0 0 .984-1v-1.14C18.74 18.41 20 16.86 20 15h-2.953v-1.14C18.74 13.41 20 11.86 20 10"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTrafficLight);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;